import { useState } from "react";
import { buscarCotaUsuarioByIdService } from "../../../services/buscarCotaUsuarioByIdService";
import { buscarCotaUsuarioByUsuarioIdService } from "../../../services/buscarCotaUsuarioByUsuarioIdService";
import { atualizarCotaUsuarioService } from "../../../services/atualizarCotaUsuarioService";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { useAtualizarArquivo } from "./useAtualizarArquivo";
import { cotaService } from "../../../services/cotaService";
import { apartamentoService } from "../../../services/apartamentoService";
import { empreendimentoByIdService } from "../../../services/empreendimentoByIdService";
import { cidadeByIdService } from "../../../services/cidadeByIdService";
import { estadoByIdService } from "../../../services/estadoByIdService";
import { representanteService } from "../../../services/representanteService";
import { usuarioService } from "../../../services/usuarioService";
import { enviarEmail } from "../../../components/Globais";

export const useAutenticar = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [success, setSuccess] = useState<string | null>("");
  const [error, setError] = useState<string | null>("");

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const { atualizarArquivo, isLoading: isLoadingExcluir } =
    useAtualizarArquivo();

  let formData: Partial<CotaUsuario> = { checked: 1 };

  const autenticar = async (
    cotaUsuarioId: number,
    arquivoCotaUsuarioId: number,
    podeExcluir: number
  ) => {
    try {
      const cotaUsuario = await buscarCotaUsuarioByIdService(cotaUsuarioId);
      if (!cotaUsuario) return;

      const infoCotaUsuario = await buscarCotaUsuarioByUsuarioIdService(
        cotaUsuario.usuarioId,
        cotaUsuarioId
      );
      if (!infoCotaUsuario) return;

      const atualizarCota = await atualizarCotaUsuarioService(
        cotaUsuarioId,
        formData
      );
      if (!atualizarCota) {
        setError("Algo deu errado ao atualizar a cota.");
        return;
      }

      const excluirArq = await atualizarArquivo(
        arquivoCotaUsuarioId,
        podeExcluir
      );

      if (excluirArq === false) {
        setError(
          "Esse arquivo já está bloqueado para exclusão. Caso queira desbloquear, fale com o administrador."
        );
        return;
      }

      if (excluirArq?.response?.data?.status === 400) {
        setError("Arquivo não encontrado ou não pode ser excluído.");
        return;
      }

      if (!excluirArq) {
        setError("Algo deu errado entre em contato conosco.");
        return;
      }

      // Continua fluxo apenas se tudo acima deu certo

      const cota = await cotaService(cotaUsuario.cotaId);
      const apartamento = await apartamentoService(cota.aptoId);
      const empreendimento = await empreendimentoByIdService(
        apartamento.empreendId
      );
      const cidade = await cidadeByIdService(empreendimento.cidadeId);
      const estado = await estadoByIdService(cidade.estadoId);
      const representante = await representanteService(cotaUsuario.id);
      const usuarioRepresentante = await usuarioService(
        representante.usuarioId
      );

      let formDataEmail = {
        tipoEmail: 2,
        userId: cotaUsuario.usuarioId,
        // Empreendimento
        empreend:
          infoCotaUsuario.CotaTable?.AptoTable?.EmpreendimentoTable?.nome ?? "",
        empreendEstado: estado.nome,
        empreendCidade: cidade.nome,
        // Apartamento
        nomeAp: apartamento.nome,
        capacidadeAp: apartamento.capacidade,
        quartosAp: apartamento.quartos,
        banheirosAp: apartamento.banheiros,
        varandaAp:
          apartamento.varanda === 1
            ? "Sim"
            : apartamento.varanda === 0
            ? "Não"
            : "Não Sei",
        terreoAp:
          apartamento.terreo === 1
            ? "Sim"
            : apartamento.terreo === 0
            ? "Não"
            : "Não Sei",
        estacionamentoAp:
          apartamento.estacionamento === 1
            ? "Sim"
            : apartamento.estacionamento === 0
            ? "Não"
            : "Não Sei",
        // Mais Info Apto
        numeroAp: cotaUsuario.numeroApto,
        andarAp: cotaUsuario.andar,
        blocoAp: cotaUsuario.bloco,
        vistaAp:
          cotaUsuario.vista === "MAR"
            ? "Mar"
            : cotaUsuario.vista === "MONTANHA"
            ? "Montanha"
            : cotaUsuario.vista === "PISCINA"
            ? "Piscina"
            : cotaUsuario.vista === "ESTACIONAMENTO"
            ? "Estacionamento"
            : "Não Sei",
        // Representante
        nomeRepresentante: usuarioRepresentante
          ? `${usuarioRepresentante.nome} ${usuarioRepresentante.sobrenome}`
          : "Não há representante",
        // Cota
        numeroCota: cota.numeroCota ?? "Não informado",
        qtdSemanas: cota.qtdSemanas ?? "Não informado",
        diaDaSemanaInicio: cota.diaDaSemanaInicio ?? "Não informado",
        prioridade: cotaUsuario.prioridade ?? "Sem Prioridade",
        // Mais Info Anuncio Propriedade
        situacaoPropriedade:
          cotaUsuario.situacao === "ESCRITURADO"
            ? "Escriturado"
            : cotaUsuario.situacao === "QUITADO"
            ? "Quitado"
            : cotaUsuario.situacao === "NA_PLANTA"
            ? "Na planta"
            : "Não Quitado",
        valorVenda: new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(cotaUsuario.valorVenda),
        valorCondominio: new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(cotaUsuario.valorCondominio),
        saldoDevedor: new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(cotaUsuario.saldoDevedor),
      };

      const resultEmail = await enviarEmail(formDataEmail);
      if (resultEmail) {
        setSuccess("Propriedade autenticada com sucesso!");
      } else {
        setError(
          "Não foi possível enviar e-mail ao proprietário. Fale com administrador."
        );
      }
    } catch (error) {
      console.error("Erro ao autenticar Arquivo:", error);
      setError("Erro inesperado. Tente novamente mais tarde.");
    } finally {
      setIsLoading(false);
    }
  };

  return { autenticar, success, error, resetError, resetSuccess, isLoading };
};
